import { Immobilie } from 'cpool-schemas';
import { z } from 'zod';

export const schemaRealEstatesForm = z.object({
    immobilien: z.array(Immobilie),
});

export type SchemaRealEstatesForm = z.infer<typeof schemaRealEstatesForm>;
